import moment from 'moment-timezone'

export function getLoginTime () {
  try {
    return parseInt(localStorage.loginTimeUnix)
  } catch (err) {
    return
  }
}

export function storeLoginTime () {
  localStorage.loginTimeUnix = Date.now()
}

export function getLoginTimeFormatted () {
  try {
    return moment(parseInt(localStorage.loginTimeUnix)).tz('America/Chicago').format('YYYY-MM-DD HH:mm:ss')
  } catch (err) {
    return ''
  }
}
